import { makeStyles } from '@material-ui/core/styles';

import { launchmetricsGrey } from 'Styles/theme';

export const useStyles = makeStyles(theme => ({
	root: {
		position: 'fixed',
		minHeight: 80,
		bottom: 16,
		left: 16,
		right: 16,
		zIndex: 2000
	},
	content: {
		padding: 16,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	text: {
		textAlign: 'center',
		fontSize: 16,
		letterSpacing: 0.44
	},
	button: {
		padding: '9px, 14px',
		marginLeft: 8,
		borderRadius: 4,
		background: '#3F3F3F',
		color: 'white',
		fontSize: 14,
		'&:hover': {
			background: launchmetricsGrey
		}
	},
	legalLink: {
		color: 'black',
		textDecoration: 'none',
		borderBottom: '1px solid black'
	}
}));
